import { LANGUAGE_CN } from '@home/_config/config';

/**
 * 获取报告详情页的语种
 * @param locale - 系统语言环境
 * @param langSegment - 报告语种segment
 * @return 报告详情的语种
 */
export const getLangOfReportDetails = (locale: string, langSegment: 'all' | (string & {})): 'en' | 'cn' => {
  const langSegmentStd = langSegment?.toLowerCase()?.replace(/\s+/g, '');
  switch (langSegmentStd) {
    case 'all': {
      return locale === LANGUAGE_CN ? 'cn' : 'en';
    }
    case 'en':
    case 'english':
    case 'englishreport': {
      return 'en';
    }
    case 'cn':
    case 'chinese':
    case 'chinesereport': {
      return 'cn';
    }
    default: {
      // 兜底情况，返回系统语言环境对应的语种即可
      return locale === LANGUAGE_CN ? 'cn' : 'en';
    }
  }
};
